import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth, startGoogleLogin } from "../../context/AuthContext";
import { CONTACT_EMAIL, IMAGES } from "../../mock";

export default function AdminLogin() {
  const { user, loading } = useAuth();
  if (!loading && user) return <Navigate to="/admin" replace />;
  return (
    <main className="min-h-screen bg-[#10271a] text-[#f6f1e7] relative overflow-hidden grain flex items-center" data-testid="admin-login">
      <img src={IMAGES.coffee.drying} alt="" className="absolute inset-0 h-full w-full object-cover opacity-20" />
      <div className="relative mx-auto max-w-[520px] w-full px-6">
        <img src="/logo-white.png" alt="Leslie West Africa Trading Company" className="h-14 w-auto" />
        <p className="mt-10 text-[#b08a5f] text-xs tracking-[0.25em] uppercase">Trade desk</p>
        <h1 className="mt-4 font-display text-4xl sm:text-5xl font-light leading-[1.0]">Sign in to the <em className="italic text-[#e9d9bf]">trade desk.</em></h1>
        <p className="mt-6 text-[#f6f1e7]/70 leading-relaxed">Enquiries, cupping notes and offers. Access is restricted to authorised Leslie West Africa accounts.</p>
        <button
          type="button"
          onClick={startGoogleLogin}
          data-testid="google-login-button"
          className="mt-10 inline-flex items-center gap-3 bg-[#f6f1e7] text-[#10271a] px-7 py-4 rounded-full text-sm tracking-[0.12em] uppercase font-semibold hover:bg-white transition-colors"
        >
          <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true"><path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9 3.5l6.7-6.7C35.6 2.6 30.2 0 24 0 14.6 0 6.5 5.4 2.5 13.3l7.8 6.1C12.2 13.6 17.6 9.5 24 9.5z"/><path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.7c-.6 3-2.3 5.5-4.8 7.2l7.5 5.8c4.4-4.1 7.1-10.1 7.1-17.5z"/><path fill="#FBBC05" d="M10.3 28.6A14.5 14.5 0 0 1 9.5 24c0-1.6.3-3.1.8-4.6l-7.8-6.1A24 24 0 0 0 0 24c0 3.9.9 7.5 2.5 10.7l7.8-6.1z"/><path fill="#34A853" d="M24 48c6.5 0 11.9-2.1 15.9-5.8l-7.5-5.8c-2.1 1.4-4.9 2.3-8.4 2.3-6.4 0-11.8-4.1-13.7-9.9l-7.8 6.1C6.5 42.6 14.6 48 24 48z"/></svg>
          Continue with Google
        </button>
        <p className="mt-6 text-xs text-[#f6f1e7]/50">Authorised account: {CONTACT_EMAIL}</p>
      </div>
    </main>
  );
}
